module.exports = __webpack_public_path__ + "static/media/mission-failed.dde2978e.wav";